const NAMESPACES = {
  DEMO: '/demo',
  SHAN_GAME: '/shan-game',
  WALLET: '/wallet'
}

export default NAMESPACES
